/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const FullLogo = (props: SVGProps<SVGSVGElement>) => {
  const { fill, height } = props;
  return (
    <svg
      height={height ?? 30}
      fill={fill ?? '#000'}
      viewBox="0 0 920 209.33333"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="g10" transform="matrix(1.333333, 0, 0, -1.333333, 0, 209.333334)">
        <g id="g12" transform="scale(0.1)">
          <path
            d="m 2429.39,1090.45 h -256.1 V 297.328 h -187 v 793.122 h -254.75 v 178.87 h 697.85 v -178.87"
            style={{
              fill: '#110f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path14"
          />
          <path
            d="m 2827.84,636.09 c 0,109.762 -79.94,187 -184.28,187 -102.99,0 -182.94,-77.238 -182.94,-187 0,-109.762 79.95,-186.988 182.94,-186.988 104.34,0 184.28,77.226 184.28,186.988 z m -542.02,0 c 0,201.898 158.54,357.73 357.74,357.73 199.19,0 359.09,-155.832 359.09,-357.73 0,-201.899 -159.9,-357.738 -359.09,-357.738 -199.2,0 -357.74,155.839 -357.74,357.738"
            style={{
              fill: '#110f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path16"
          />
          <path
            d="M 3318.48,806.828 V 524.98 c 0,-73.171 52.85,-74.531 153.12,-69.109 V 297.328 c -245.26,-27.109 -327.92,44.711 -327.92,227.652 v 281.848 h -117.89 v 168.024 h 117.89 v 136.858 l 174.8,52.85 V 974.852 H 3471.6 V 806.828 h -153.12"
            style={{
              fill: '#110f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path18"
          />
          <path
            d="m 4062.46,636.09 c 0,113.82 -79.95,191.058 -188.35,191.058 -107.05,0 -187,-77.238 -187,-191.058 0,-113.82 79.95,-191.059 187,-191.059 108.4,0 188.35,77.239 188.35,191.059 z m 174.8,338.762 V 297.328 h -174.8 v 79.953 c -48.78,-60.98 -121.95,-98.929 -220.88,-98.929 -180.21,0 -329.28,155.839 -329.28,357.738 0,201.898 149.07,357.73 329.28,357.73 98.93,0 172.1,-37.941 220.88,-98.91 v 79.942 h 174.8"
            style={{
              fill: '#110f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path20"
          />
          <path
            d="m 4341.71,1269.79 h 174.8 V 297.328 h -174.8 v 972.462"
            style={{
              fill: '#110f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path22"
          />
          <path
            d="M 5227.34,465.82 V 292.328 h -569.16 v 977.332 h 562.58 V 1096.14 H 4839.57 V 900.289 h 348.32 V 729.422 H 4839.57 V 465.82 h 387.77"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path24"
          />
          <path
            d="M 5941.24,1096.14 H 5692.82 V 292.328 H 5511.41 V 1096.14 H 5264.3 v 173.52 h 676.94 v -173.52"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path26"
          />
          <path
            d="m 6704.52,782.211 c 0,181.758 -133.3,309.679 -304.29,309.679 -171.01,0 -304.31,-127.921 -304.31,-309.679 0,-180.43 133.3,-308.34 304.31,-308.34 170.99,0 304.29,127.91 304.29,308.34 z m -793.07,0 c 0,276.019 216.78,490.109 488.78,490.109 271.98,0 490.11,-214.09 490.11,-490.109 0,-274.68 -218.13,-490.109 -490.11,-490.109 -272,0 -488.78,215.429 -488.78,490.109"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path28"
          />
          <path
            d="m 2429.39,1090.45 h -256.1 V 297.328 h -187 v 793.122 h -254.75 v 178.87 h 697.85 v -178.87"
            style={{
              fill: '#current',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path30"
          />
          <path
            d="m 2827.84,636.09 c 0,109.762 -79.94,187 -184.28,187 -102.99,0 -182.94,-77.238 -182.94,-187 0,-109.762 79.95,-186.988 182.94,-186.988 104.34,0 184.28,77.226 184.28,186.988 z m -542.02,0 c 0,201.898 158.54,357.73 357.74,357.73 199.19,0 359.09,-155.832 359.09,-357.73 0,-201.899 -159.9,-357.738 -359.09,-357.738 -199.2,0 -357.74,155.839 -357.74,357.738"
            style={{
              fill: '#current',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path32"
          />
          <path
            d="M 3318.48,806.828 V 524.98 c 0,-73.171 52.85,-74.531 153.12,-69.109 V 297.328 c -245.26,-27.109 -327.92,44.711 -327.92,227.652 v 281.848 h -117.89 v 168.024 h 117.89 v 136.858 l 174.8,52.85 V 974.852 H 3471.6 V 806.828 h -153.12"
            style={{
              fill: '#current',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path34"
          />
          <path
            d="m 4062.46,636.09 c 0,113.82 -79.95,191.058 -188.35,191.058 -107.05,0 -187,-77.238 -187,-191.058 0,-113.82 79.95,-191.059 187,-191.059 108.4,0 188.35,77.239 188.35,191.059 z m 174.8,338.762 V 297.328 h -174.8 v 79.953 c -48.78,-60.98 -121.95,-98.929 -220.88,-98.929 -180.21,0 -329.28,155.839 -329.28,357.738 0,201.898 149.07,357.73 329.28,357.73 98.93,0 172.1,-37.941 220.88,-98.91 v 79.942 h 174.8"
            style={{
              fill: '#current',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path36"
          />
          <path
            d="m 4341.71,1269.79 h 174.8 V 297.328 h -174.8 v 972.462"
            style={{
              fill: '#current',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path38"
          />
          <path
            d="M 5227.34,465.82 V 292.328 h -569.16 v 977.332 h 562.58 V 1096.14 H 4839.57 V 900.289 h 348.32 V 729.422 H 4839.57 V 465.82 h 387.77"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path40"
          />
          <path
            d="M 5941.24,1096.14 H 5692.82 V 292.328 H 5511.41 V 1096.14 H 5264.3 v 173.52 h 676.94 v -173.52"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path42"
          />
          <path
            d="m 6704.52,782.211 c 0,181.758 -133.3,309.679 -304.29,309.679 -171.01,0 -304.31,-127.921 -304.31,-309.679 0,-180.43 133.3,-308.34 304.31,-308.34 170.99,0 304.29,127.91 304.29,308.34 z m -793.07,0 c 0,276.019 216.78,490.109 488.78,490.109 271.98,0 490.11,-214.09 490.11,-490.109 0,-274.68 -218.13,-490.109 -490.11,-490.109 -272,0 -488.78,215.429 -488.78,490.109"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path44"
          />
          <path
            d="M 675.109,87.9414 156.398,374.57 V 850.801 L 732.961,1169.38 1085.77,974.879 V 1159.18 L 732.961,1354.09 0,948.891 V 285.109 L 515.891,0 675.109,87.9414"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path46"
          />
          <path
            d="M 1311.02,1034.68 1310.09,401.02 906.199,177.801 347.672,486.941 347.699,918.512 189.68,831.211 V 395.578 L 906.199,0 1468.27,310.379 V 947.25 l -157.25,87.43"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path48"
          />
          <path
            d="m 189.66,1090.49 543.379,300.53 385.931,-213.54 -0.2,-676.96 L 756.102,299.789 905.949,216.852 1276.71,421.621 1276.43,1269.4 733.039,1570 189.66,1269.42 v -178.93"
            style={{
              fill: '#f44336',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path50"
          />
        </g>
      </g>
    </svg>
  );
};

export default FullLogo;
